import React, { useRef } from 'react';
import { AddContactsToList } from '@/components/Contacts/CommonActions/AddToList';
import {
    useContactsCount,
    useSelectedEntity,
    useContactQueryParams,
    useEntityRuleForFiltration,
} from '@/components/Contacts/Group/hooks';
import { ShowDialog, HideDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { ListAddStart, ListMoveContactsStart, ListAddContactsStart } from '@/store/lists/actions';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ContactTableContext } from '../../context';

export const useAddContactsToList = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isNewListSelected = useRef(false);
    const selectedListName = useRef('');

    const contactCount = useContactsCount();
    const { isAllContactsSegment, selectedEntity, isSelectedEntityAList } = useSelectedEntity();
    const { pushParamToUrl } = useContactQueryParams();
    const { selectedRows, selectedAll, setSelectedRows } = useContext(ContactTableContext);
    const { filtrationRuleWithQuery } = useEntityRuleForFiltration();

    const setUserChoise = (isNewList, selectedList) => {
        isNewListSelected.current = isNewList;
        selectedListName.current = selectedList;
    };

    const addContactToList = (moveContactsToNewList: boolean, email?: string): void => {
        const selectedContactsCount = selectedAll ? contactCount : selectedRows?.length || +!!email;

        const contactsText = t('contactsplural', { count: selectedContactsCount });
        const dialogTitle = `${moveContactsToNewList ? t('move') : t('add')} ${contactsText} ${t('tolist')}`;

        const emailsToAdd = !!email ? [email] : selectedRows;

        const params: ShowDialogParams = {
            title: dialogTitle,
            confirmLabel: t('save'),
            onClickConfirm: (): void => {
                const filtrationParams = {
                    rule: selectedAll ? filtrationRuleWithQuery : null,
                    emails: selectedAll ? null : emailsToAdd,
                    allContacts: isAllContactsSegment,
                };

                handleAddToListConfirm(filtrationParams, moveContactsToNewList);
            },
            cancelLabel: t('cancel'),
            body: <AddContactsToList moveContacts={moveContactsToNewList} onChange={setUserChoise} />,
        };
        dispatch(ShowDialog(params));
    };
    const isList = isSelectedEntityAList(selectedEntity);

    const handleAddToListConfirm = (
        filtrationParams: {
            rule: string;
            emails: string[];
            allContacts: boolean;
        },
        moveContacts: boolean
    ): void => {
        console.log(
            selectedAll
                ? {
                      ListName: selectedListName?.current,
                      Rule: filtrationParams.rule,
                      AllContacts: !filtrationParams.rule,
                  }
                : { ListName: selectedListName?.current, Emails: filtrationParams.emails }
        );
        switch (true) {
            case isNewListSelected.current:
                dispatch<any>(
                    ListAddStart(
                        selectedAll
                            ? {
                                  ListName: selectedListName?.current,
                                  Rule: filtrationParams.rule,
                                  AllContacts: !filtrationParams.rule,
                              }
                            : { ListName: selectedListName?.current, Emails: filtrationParams.emails }
                    )
                ).then(() => dispatch(HideDialog()));
                break;
            case moveContacts:
                dispatch(
                    ListMoveContactsStart(isList && selectedEntity.ListName, {
                        newListName: selectedListName?.current,
                        emails: selectedAll ? null : filtrationParams.emails,
                        rule: selectedAll ? filtrationParams.rule : null,
                    })
                );
                break;
            default:
                dispatch(
                    ListAddContactsStart(
                        selectedListName.current,
                        selectedAll
                            ? { rule: filtrationParams.rule, allContacts: !filtrationParams.rule }
                            : { emails: filtrationParams.emails }
                    )
                );
                break;
        }

        pushParamToUrl({ statuses: null });
        setSelectedRows([]);
    };

    return { addContactToList };
};
